import React, { useState } from "react";
import { ProductCard } from "../../../components/ProductCard/ProductCard";
import { loadMoreTexts } from "../../../assets/Helpers";

import "./ProductsGrid.scss";

export const ProductsGrid = (props) => {
  const [showMoreButtonText, setShowMoreButtonText] = useState(
    loadMoreTexts.default
  );

  if (props.loading || !props.productsData) {
    return (
      <div className="d-flex justify-content-center">
        <div className="loader mt-40"></div>
      </div>
    );
  }

  if (props.error) {
    return (
      <>
        <p>Ju lutemi provoni përseri.</p>
      </>
    );
  }

  const products = props.productsData?.products?.nodes || [];
  return (
    <div id="ProductsGrid" className="ProductsGrid">
      <div className="products">
        {products.map((product) => {
          return <ProductCard key={product.id || product.productId} product={product} />;
        })}
      </div>
    </div>
  );
};
